var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.1",
    points: "271 373 366 373 366 383.95 393 383.95 393 535 271 535 271 373"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.3.2",
    x: 80.7,
    y: 373,
    width: 186.36,
    height: 162
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.3",
    points: "93 201 267 201 267 331.88 166 331.88 166 368 93 368 93 201"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.4",
    points: "271 188 393 188 393 331.88 298 331.88 298 321 271 321 271 188"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.5",
    points: "396.64 188 518.87 188 518.87 320.78 492 320.78 492 332 396.64 332 396.64 188"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.6",
    points: "523.3 188 645 188 645 332 550 332 550 321 523.3 321 523.3 188"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.7",
    points: "650 170 771 170 771 321 744 321 744 332 649 332 649 170 650 170"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.8",
    points: "775.32 170 911 170 911 303 898 303 898 368 775.32 368 775.32 170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.3.9",
    x: 747,
    y: 373,
    width: 151,
    height: 131
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.3.10",
    x: 649,
    y: 373,
    width: 93,
    height: 131
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.3.11",
    points: "550.03 373 645 373 645 516 523 516 523 384.13 550 384.13 550.03 373"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OTAgNzIwIj4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4zLjEiIHBvaW50cz0iMjcxIDM3MyAzNjYgMzczIDM2NiAzODMuOTUgMzkzIDM4My45NSAzOTMgNTM1IDI3MSA1MzUgMjcxIDM3MyIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjMuMiIgeD0iODAuNyIgeT0iMzczIiB3aWR0aD0iMTg2LjM2IiBoZWlnaHQ9IjE2MiIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjMuMyIgcG9pbnRzPSI5MyAyMDEgMjY3IDIwMSAyNjcgMzMxLjg4IDE2NiAzMzEuODggMTY2IDM2OCA5MyAzNjggOTMgMjAxIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMy40IiBwb2ludHM9IjI3MSAxODggMzkzIDE4OCAzOTMgMzMxLjg4IDI5OCAzMzEuODggMjk4IDMyMSAyNzEgMzIxIDI3MSAxODgiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4zLjUiIHBvaW50cz0iMzk2LjY0IDE4OCA1MTguODcgMTg4IDUxOC44NyAzMjAuNzggNDkyIDMyMC43OCA0OTIgMzMyIDM5Ni42NCAzMzIgMzk2LjY0IDE4OCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjMuNiIgcG9pbnRzPSI1MjMuMyAxODggNjQ1IDE4OCA2NDUgMzMyIDU1MCAzMzIgNTUwIDMyMSA1MjMuMyAzMjEgNTIzLjMgMTg4Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMy43IiBwb2ludHM9IjY1MCAxNzAgNzcxIDE3MCA3NzEgMzIxIDc0NCAzMjEgNzQ0IDMzMiA2NDkgMzMyIDY0OSAxNzAgNjUwIDE3MCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjMuOCIgcG9pbnRzPSI3NzUuMzIgMTcwIDkxMSAxNzAgOTExIDMwMyA4OTggMzAzIDg5OCAzNjggNzc1LjMyIDM2OCA3NzUuMzIgMTcwIi8+CgoKICAgIDxyZWN0IGRhdGEtaWQ9IkIuMy45IiB4PSI3NDciIHk9IjM3MyIgd2lkdGg9IjE1MSIgaGVpZ2h0PSIxMzEiLz4KCgogICAgPHJlY3QgZGF0YS1pZD0iQi4zLjEwIiB4PSI2NDkiIHk9IjM3MyIgd2lkdGg9IjkzIiBoZWlnaHQ9IjEzMSIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjMuMTEiIHBvaW50cz0iNTUwLjAzIDM3MyA2NDUgMzczIDY0NSA1MTYgNTIzIDUxNiA1MjMgMzg0LjEzIDU1MCAzODQuMTMgNTUwLjAzIDM3MyIvPgoKPC9zdmc+";
export { SvgPB3 as ReactComponent };